<template>
	<Popup
		v-model="selfDisplay"
		title="充值记录"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<!-- 表格 -->
			<div class="base_table">
				<el-table
					:data="tabData"
					style="width: 100%"
				>
					<el-table-column
						prop="mid"
						label="机器ID"
					>
					</el-table-column>
					<el-table-column
						prop="origin"
						label="来源"
					>
					</el-table-column>
					<el-table-column
						prop="mete"
						label="量"
					>
					</el-table-column>
					<el-table-column
						prop="originInfo"
						label="来源信息"
					>
					</el-table-column>
					<el-table-column
						prop="originId"
						label="来源ID"
					>
					</el-table-column>
					<el-table-column
						prop="money"
						label="金额"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="page"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end-->
		</div>
	</Popup>
</template>

<script>
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				page: 1,
				total: 0,
				tabData: []
			}
		},
		methods: {
			// 切换页码
			handlePageChange() {}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
			}
		}
	}
</script>

<style>
</style>
